const dateFormat = require('dateformat');

export class AvailabilityFilter {

    constructor(selector, selected) {
        this.selectInput = jQuery(selector);

        if (this.selectInput) {
            // init select2 
            jQuery(this.selectInput).select2({
                allowClear: true,
                minimumResultsForSearch: -1,
                placeholder: "Select...",
                width: '100%'
            }).on('select2:unselecting', function () {
                jQuery(this).data('unselecting', true);
            }).on('select2:opening', function (e) {
                if (jQuery(this).data('unselecting')) {
                    jQuery(this).removeData('unselecting');
                    e.preventDefault();
                }
            });
        }

        if (cur_availability !== '') {
            jQuery(this.selectInput).val(cur_availability).trigger('change');
        }
    }

    filter(unit) {
        var dateAvailable = unit.data('available-date');
        var days = parseInt(jQuery(this.selectInput).val());

        if (!this.selectInput || dateAvailable === '' || isNaN(days)) {
            return true;
        }

        //turn date values into time strings to allow for comparison
        dateAvailable = dateAvailable.split("/");
        dateAvailable = new Date(dateAvailable[2], dateAvailable[0] - 1, dateAvailable[1]);
        dateAvailable = dateFormat(dateAvailable, "yyyy-mm-dd");

        // Immediate
        if (days == 0) {
            var filterDate = dateFormat(new Date(), "yyyy-mm-dd");
            return dateAvailable == filterDate;
        }
        // Filter In +days ie. Less then a Month
        else if (days > 0) {
            var filterDate = new Date();
            filterDate.setDate(filterDate.getDate() + days);
            filterDate = dateFormat(filterDate, "yyyy-mm-dd");
            return dateAvailable <= filterDate;
        }
        // Filter In -days ie. More then a Month
        else if (days < 0) {
            var filterDate = new Date();
            filterDate.setDate(filterDate.getDate() + (days * -1));
            filterDate = dateFormat(filterDate, "yyyy-mm-dd");
            return dateAvailable >= filterDate;
        }

    }

};